import rules from '../../../plugins/form-rules';

export default {
  required: {
    address: [rules.required, rules.specialCharacteresNotAllowed],
    unit: [rules.specialCharacteresNotAllowed],
    city: [rules.required, rules.specialCharacteresNotAllowed],
    state: [rules.required],
    zipCode: [rules.required, rules.zip],
  },
  optional: {
    address: [rules.optional(rules.specialCharacteresNotAllowed)],
    unit: [rules.optional(rules.specialCharacteresNotAllowed)],
    city: [rules.optional(rules.specialCharacteresNotAllowed)],
    state: [rules.optional(rules.state)],
    zipCode: [rules.optional(rules.zip)],
  },
};
